import React from 'react';
import { lazyAfterPaint } from 'react-loosely-lazy';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries';
import Placeholder from '@atlassian/jira-placeholder';
import { useViewEpicPanelExperienceTracker } from './services/experience-tracker';
import type { Props } from './ui/epic';
import type EpicPanelType from './index';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const EpicPanel = lazyAfterPaint<typeof EpicPanelType>(
	() => import(/* webpackChunkName: "async-software-backlog-panel" */ './index'),
	{ ssr: false },
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (props: Props) => {
	const { fireErrorBoundaryExperienceFail } = useViewEpicPanelExperienceTracker({
		isClassic: props.isCompanyManaged || false,
	});
	return (
		<JSErrorBoundary
			id="async.jira.backlog.panel"
			packageName="jiraSoftwareBacklogPanel"
			fallback="flag"
			teamName="a4t-pandora"
			onError={fireErrorBoundaryExperienceFail}
		>
			<Placeholder name="backlog-panel-boundary" fallback={<></>}>
				<EpicPanel {...props} />
			</Placeholder>
		</JSErrorBoundary>
	);
};
